import { render, staticRenderFns } from "./ContactsHistory.vue?vue&type=template&id=4836d6de&"
import script from "./ContactsHistory.vue?vue&type=script&lang=js&"
export * from "./ContactsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ContactsHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports